const messages = {
  archived: "Archived",
  assortments: "Assortments",
  brandNotes: "Brand Notes",
  browseCatalog: "Browse Catalog",
  connections: "Connections",
  createStyle: "Create a Style",
  createStyleboard: "Create a Styleboard",
  discover: "Discover",
  helpCenter: "Help Center",
  logout: "Log Out",
  looks: "Looks",
  manageConnections: "Manage Connections",
  manageProfile: "Manage Profile",
  manageWorkspaces: "Manage Workspaces",
  mySettings: "My settings",
  passport: "Passport",
  pendingConnections: "Pending Connections",
  reporting: "Reporting",
  shop: "Shop",
  styleboards: "Styleboards",
  switchTo: "Switch To",
  workspaces: "Workspaces",
};

export default messages;
